import { NodeSpec } from 'prosemirror-model';

import Paragraph from '../Paragraph';

export default class InlineEditorParagraph extends Paragraph {
  get schema(): NodeSpec {
    return {
      ...this._schema,
      parseDOM: [
        {
          tag: 'p',
          getAttrs: (element) => {
            // Do not parse as paragraph if there's no text content inside element, fixes images inside p tag issue.
            return typeof element !== 'string' && element?.getElementsByTagName('img')[0]
              ? false
              : null;
          },
        },
        // parse headings as paragraphs because we don't support headings in inline editor
        {
          tag: 'h1',
        },
        {
          tag: 'h2',
        },
        {
          tag: 'h3',
        },
        {
          tag: 'h4',
        },
        {
          tag: 'h5',
        },
        {
          tag: 'h6',
        },
      ],
      toDOM: () => ['p', 0],
    };
  }
}
